export function pascalCasify(str) {
  /*
    Converts a string from hypenated case (e.g. battery-swapping) to PascalCase.
   */
  const route = str.split("-");
  return route
    .map(word => {
      if (str.length > 0) {
        return word[0].toUpperCase() + word.slice(1);
      }
      return "";
    })
    .join("");
}

export function fileNamify(name) {
  return name
    .split(" ")
    .map(word => word.toLowerCase())
    .join("_");
}

export function underscoresToSpaces(string) {
  return string.split("_").join(" ");
}

export function padZero(str, max = 6) {
  const newStr = str.toString();
  return newStr.length < max ? padZero(`0${newStr}`, max) : newStr;
}

export function capitalizeFirstWord(str) {
  if (!str || str.length === 0) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const validateSemVar = version => {
  // https://regex101.com/r/HPtVlh/1
  // eslint-disable-next-line max-len
  const regex = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(-(0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(\.(0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*)?(\+[0-9a-zA-Z-]+(\.[0-9a-zA-Z-]+)*)?$/;

  return regex.test(version);
};
